export default "__VITE_ASSET__gevk3qpA__"